import React, { useEffect } from 'react';
import { OrderList as UIOrderList } from '@shopee/chatbot-ui';
import { OrderListProps as UIOrderListProps } from '@shopee/chatbot-ui/lib/components/OrderList';
import { TFEOrderUserType, OrderCardType } from '@/utils/constants';
import { ChatbotUIBasicProps } from '@/types/common';
import { UseProps } from './PropsProtocol/OrderList';
import DetectUserInteraction, {
  DetectUserInteractionInstance,
  useDetectUserInteraction,
} from '../DetectUserInteraction';
import { updateDialogueInfo, updateDialogueOuterData } from '@/utils/sessionUtils';
import { afterDialogueShow } from '@/utils/tools';

export type OrderListProps = UIOrderListProps & {
  selectOtherAction: any;
  selectAction: any;
  selectOtherContent: string;
  selectContent: string;
  defaultStatus: string;
  statusText: number[];
  userType: TFEOrderUserType;
  taskbotInfo: any;
  closeOtherAction?: any;
  orderCardType?: OrderCardType;
  chatbotComponentType?: any;
  moreButtonText: string;
  selectOrderButtonText: string;
  listPos: number;
  shouldDisplayInstantly?: boolean;
  delayDisplayRecommendIntentSelector?: boolean;
} & ChatbotUIBasicProps;

const OrderList = (props: OrderListProps) => {
  const userInteractionInstance = useDetectUserInteraction();
  const orderListProps = UseProps(props.chatbotComponentType, userInteractionInstance, props);

  return (
    props.shouldDisplayInstantly && props.delayDisplayRecommendIntentSelector
      ? <DetectOrderListInteraction instance={userInteractionInstance} {...props}>
        <UIOrderList {...orderListProps} />
      </DetectOrderListInteraction> : <UIOrderList {...orderListProps} />
  );
};

type DetectOrderListInteractionProps = {
  listPos: number;
  instance: DetectUserInteractionInstance
} & ChatbotUIBasicProps;


const DetectOrderListInteraction: React.FC<DetectOrderListInteractionProps> = (props) => {
  const onStopInteraction = () => {
    updateDialogueInfo(
      { shouldDisplayInstantly: false },
      props.listPos,
    );

    updateDialogueOuterData(
      { hidden: false },
      props.listPos + 1,
    );
    afterDialogueShow();
  };

  useEffect(() => {
    props.instance.current?.start?.();
  }, []);


  return <DetectUserInteraction duration={2} onEnd={onStopInteraction} instance={props.instance}>
    {props.children}
  </DetectUserInteraction>;

};

export default OrderList;
